import React from 'react';
import GalleriesPage from "../../features/pages/GalleriesPage";
import galleryApiService from "../../services/galleryApiService";

const Galleries = ({galleries}) => <GalleriesPage galleries={galleries} />

export const getServerSideProps = async () => {
  const response = await galleryApiService.galleries()

  return {
    props: {
      galleries: response.data
    }
  }
}

export default Galleries;
